import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  OnDestroy,
  QueryList,
} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomTableCellComponent } from '../custom-table-cell/custom-table-cell.component';

@Component({
  selector: 'app-custom-table-header',
  templateUrl: './custom-table-header.component.html',
  styleUrls: ['./custom-table-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTableHeaderComponent implements AfterViewInit, OnDestroy {
  @ContentChildren(CustomTableCellComponent)
  cells?: QueryList<CustomTableCellComponent>;

  headerCellsChanged = new BehaviorSubject<CustomTableCellComponent[]>([]);

  private destroyed$ = new Subject<void>();

  constructor() {}

  ngAfterViewInit() {
    this.updateCellsOnChanges();
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  updateCellsOnChanges(): void {
    if (!this.cells) {
      return;
    }
    this.updateCells(this.cells.toArray());
    this.cells.changes.pipe(takeUntil(this.destroyed$)).subscribe((cells) => {
      this.updateCells(cells);
    });
  }

  updateCells(cells: CustomTableCellComponent[]) {
    this.headerCellsChanged.next(cells);
  }
}
